import { style, classes } from 'typestyle';
import { NestedCSSProperties } from 'typestyle/lib/types';
import { isNil } from 'lodash';
import { PathMatch } from 'react-router-dom';

const COLLAPSED_SIDNAV_WIDTH = 54;
const FULL_SIDENAV_WIDTH = 225;

const iconStyle: NestedCSSProperties = {
  position: 'relative',
  left: -18,
};

const COLLAPSE_ICON_FULL_LEFT = 202;
const sidebar = (scrollBarShowed: boolean) =>
  style({
    $debugName: 'sidebar',
    background: '#f4f3f4',
    overflowY: 'auto',
    overflowX: 'hidden',
    flexShrink: 0,
    padding: 0,
    borderRight: '1px solid #dee2e6',
    width: FULL_SIDENAV_WIDTH + (scrollBarShowed ? 15 : 0),
    $nest: {
      '& .collapseIconContainer': {
        position: 'relative',
        fontSize: 15,
        left: COLLAPSE_ICON_FULL_LEFT,
        marginTop: 1,
        cursor: 'pointer',
        top: -22,
        color: '#8c8c8c',
      },
    },
  });

const title = style({
  $debugName: 'title',
  fontSize: '12px',
});
const textTitleStyle = style({
  fontWeight: 700,
  textAlign: 'center',
  paddingTop: '1.5rem',
  color: '#8c8c8c',
  lineHeight: 1.5,
});
const activeGroup = style({
  $debugName: 'activeGroup',
  color: '#00a89b',
});

const groupTitle = style({
  $debugName: 'groupTitle',
  fontSize: '12px',
  padding: '0.5rem',
  margin: 0,
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  $nest: {
    '&.text-is-in-view': {
      color: '#ffffff',
    },
  },
});

const sectionStyle = style({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  width: '100%',
});

function groupCollapser(isExpanded: boolean, isViewIn: boolean) {
  if (isExpanded) {
    return classes(groupTitle, style({ color: '#00a89b' }), sectionStyle);
  }
  if (isViewIn) {
    return classes(groupTitle, 'text-is-in-view', style({ backgroundColor: '#00a89b' }), sectionStyle,  'w-100');
  }
  return classes(groupTitle, style({ color: '#8c8c8c' }), sectionStyle);
}

function navLink(routeMatch: PathMatch | null, disabled?: boolean) {
  return classes(
    style({
      color: routeMatch ? 'white' : '#8c8c8c',
      backgroundColor: routeMatch ? '#00a89b' : undefined,
      paddingLeft: '2rem',
      padding: '0.4rem 1rem',
      display: 'block',
      lineHeight: 1.5,
      $nest: {
        '&:hover': {
          color: routeMatch ? 'white' : '#666',
          backgroundColor: routeMatch ? '#00756c' : undefined,
        },
      },
    }),
    disabled && 'disabled'
  );
}
const sectionItemStyle = style({
  flex: ' 0 0 auto',
  width: '8.333333%',
  maxWidth: '8.333333%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '0 15px',
});
const collapsedCaret = style({
  transform: 'rotate(0deg)',
  transition: 'transform 0.2s linear',
});

const expandedCaret = style({
  transform: 'rotate(180deg)',
  transition: 'transform 0.2s linear',
});

// Nesting should be okay as it only affects the Sidenav div
const collapsedSidenavStyles = (scrollBarShowed: boolean) =>
  style({
    width: COLLAPSED_SIDNAV_WIDTH + (scrollBarShowed ? 15 : 0),
    whiteSpace: 'nowrap',
    zIndex: 102,
    $nest: {
      '& .collapseIconContainer': {
        left: 24,
        fontSize: 19,
      },
      '& .sectionNameDisplayed': {
        opacity: 0,
      },
      '& .item-icon > i': iconStyle,
    },
  });
const warningIcon = {
  fontSize: '1rem',
};
const viewName = {
  fontSize: '.75rem',
  flex: '0 0 auto',
  width: '91.666667%',
  maxWidth: '91.666667%',
  padding: '0 15px',
};
const navItemWrapper = (isErrorView: boolean | undefined) => {
  const isError = !isNil(isErrorView) && isErrorView === true;
  return style({
    display: 'flex',
    color: isError ? 'red' : '',
    cursor: isError ? 'not-allowed' : 'pointer',
    alignItems: 'center',
  });
};

const fakeSidenavDivForSpacing = (scrollBarShowed: boolean) =>
  style({
    width: COLLAPSED_SIDNAV_WIDTH + (scrollBarShowed ? 15 : 0),
    height: '100%',
  });

const mfpFavoriteSidenav = (active: boolean) =>
  style({
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    backgroundColor: active ? '#00a89b' : '',
    $nest: {
      li: {
        maxWidth: '80%',
        wordBreak: 'break-word',
      },
      a: {
        color: active ? 'white !important' : '',
      },
      '.remove-favorite': {
        backgroundColor: 'inherit',
        border: 'none',
      },
    },
  });
const sideNavColumn = style({
  display: 'flex',
  flexDirection: 'column',
  marginTop: 0,
  flexWrap: 'wrap',
  paddingLeft: 0,
  marginBottom: 0,
  listStyle: 'none',
});
const generalCol = style({
  position: 'relative',
  width: '100%',
  padding: '0 15px',
});
const iconSectionContainer = style({
  flex: '0 0 8.33333333%',
  maxWidth: '8.33333333%',
});
const titleSectionContainer = style({
  flex: '0 0 66.66666667%',
  maxWidth: '66.66666667%',
});
export default {
  sidebar,
  title,
  textTitleStyle,
  activeGroup,
  groupTitle,
  groupCollapser,
  navLink,
  collapsedCaret,
  expandedCaret,
  collapsedSidenavStyles,
  fakeSidenavDivForSpacing,
  navItemWrapper,
  warningIcon,
  viewName,
  mfpFavoriteSidenav,
  sideNavColumn,
  sectionItemStyle,
  titleSectionContainer,
  iconSectionContainer,
  generalCol,
};
